import React from 'react';
import { WithDmId } from '../../utils/BaseProps';

import Spacer from '../Layout/Spacer/index';
import Box from '../Layout/Box/index';

type SeparatorProps = WithDmId & {
  /**
   * Optional kann das Styling des Container-Elements überschrieben werden.
   * Davon sollte nur im Ausnahmefall Gebrauch gemacht werden.
   */
  style?: object;
  [otherProp: string]: any;
};

function defaultStyle() {
  return { marginTop: 13, marginBottom: 20 };
}

export default function Separator({
  style,
  dmId = 'dm-separator',
  ...otherProps
}: SeparatorProps): React.ReactElement {
  return (
    <Box data-dmid={dmId} data-designsystem style={[defaultStyle, style]}>
      <Spacer
        style={({ theme }: { theme: any }) => ({
          borderBottom: `2px solid ${theme.palette.color4.hex}`,
        })}
        size={0}
        {...otherProps}
      />
    </Box>
  );
}
